
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/creator-join",
      function () {
        return require("private-next-pages/creator-join.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/creator-join"])
      });
    }
  